
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class JobHoldAction extends Vue {
  @Prop({ type: String, required: true }) readonly buttonText!: string;
  @Prop({ type: String, required: true }) readonly confirmationText!: string;
  @Prop({ type: Boolean, default: false }) readonly isLoading!: boolean;

  private isConfirming = false;

  public startConfirmation(): void {
    this.isConfirming = true;
    this.$emit('start-confirmation');
  }

  public cancelConfirmation(): void {
    this.isConfirming = false;
    this.$emit('cancel-confirmation');
  }

  public completeAction(): void {
    this.$emit('complete-action');
  }
}
